import * as React from 'react';
export var AvailableServicesCountContext = React.createContext({ order: null, selectedServices: null });
var AvailableServicesCountContextProvider = AvailableServicesCountContext.Provider;
export default AvailableServicesCountContextProvider;
